import * as Sentry from "@sentry/react";
import { DownloadSpeedHelper } from "app/helpers/downloadSpeedHelper";
import { TimeDateHelper } from "app/helpers/timeDateHelper";
import { SessionType } from "app/types/userType";
import { ResponsiveScreenSizes, startSpeedCheckDelay } from "app/utils/const";
import React, { Component } from "react";
import { injectIntl, IntlShape } from "react-intl";
import Media from "react-media";
import { connect } from "react-redux";
import "./DownloadSpeed.scss";

type Props = {
  intl: IntlShape;
  downloadSpeed: {
    mbps?: string;
  };
  selectedView: string;
  session: SessionType;
  isPageVisible: boolean;
};
type State = {
  mouseOverMessage: boolean;
  numberSlowMessageSentToSentry: number;
  numberCancelSlowMessageSentToSentry: number;
};

class DownloadSpeed extends Component<Props, State> {
  idleTimer: any;
  intervalId: any;
  startDelayTimeout: any;
  //
  constructor(props: Props) {
    super(props);
    this.intervalId = null;
    // default state for mouseOverMessage
    this.state = {
      mouseOverMessage: false,
      numberSlowMessageSentToSentry: 0,
      numberCancelSlowMessageSentToSentry: 0,
    };
  }

  componentDidMount = () => {
    // start polling on mount if not running on localhost
    this.startDelayTimeout = setTimeout(
      () => {
        window.location.hostname !== "localhost" &&
          this.startPollingDownloadSpeed();
      },
      startSpeedCheckDelay,
      this
    );
  };

  componentWillUnmount() {
    // stop polling on unmount
    this.stopPollingDownloadSpeed();
    this.startDelayTimeout && clearTimeout(this.startDelayTimeout);
  }

  startPollingDownloadSpeed = () => {
    DownloadSpeedHelper.getNetworkDownloadSpeed();
    this.intervalId = setInterval(() => {
      this.props.isPageVisible && DownloadSpeedHelper.getNetworkDownloadSpeed();
    }, 15000);
  };
  stopPollingDownloadSpeed = () => {
    clearInterval(this.intervalId);
  };
  updateBackgroundColor = () => {
    const { downloadSpeed } = this.props;

    if (downloadSpeed.mbps !== undefined) {
      const speed = parseFloat(downloadSpeed.mbps);

      // leaving at 5.5mbps to make easier for QA testing
      if (speed >= 5.5) {
        return "fast";
      } else {
        return "slow";
      }
    }
  };
  showOnHoverMessage = () => {
    this.setState({
      mouseOverMessage: !this.state.mouseOverMessage,
    });
  };
  componentDidUpdate = (prevProps, prevState) => {
    const prevSpeed =
      prevProps.downloadSpeed.mbps != null
        ? parseFloat(prevProps.downloadSpeed.mbps)
        : null;
    prevSpeed != null && this.sendMessageToSentry(prevSpeed);
  };

  // Only send to sentry 5 times to prevent excess logs
  sendMessageToSentry = (prevSpeed: number) => {
    const { session, downloadSpeed } = this.props;

    const speed =
      downloadSpeed.mbps != null ? parseFloat(downloadSpeed.mbps) : 0;
    const time = TimeDateHelper.getUTCFormattedDateTime("HH:mm:ss:SSS");
    if (
      prevSpeed != null &&
      speed < 5.5 &&
      prevSpeed >= 5.5 &&
      this.state.numberSlowMessageSentToSentry < 6
    ) {
      const slowNetworkMessage = `Slow network warning: User :${session.username} IPAddress:${session.ipAddress} uiViewMode:${session.uiViewMode} Speed:${speed}Mbps Time: ${time}`;
      console.log("SEND MESSAGE TO SENTRY: ", slowNetworkMessage);
      Sentry.captureMessage(slowNetworkMessage);
      this.setState({
        numberSlowMessageSentToSentry:
          this.state.numberSlowMessageSentToSentry + 1,
      });
    }
    if (
      prevSpeed != null &&
      speed >= 5.5 &&
      prevSpeed < 5.5 &&
      this.state.numberCancelSlowMessageSentToSentry < 6
    ) {
      const slowNetworkMessage = `Cancel slow network warning: User :${session.username} IPAddress:${session.ipAddress} uiViewMode:${session.uiViewMode} Speed:${speed}Mbps Time: ${time}`;
      console.log("SEND MESSAGE TO SENTRY : ", slowNetworkMessage);
      Sentry.captureMessage(slowNetworkMessage);
      this.setState({
        numberCancelSlowMessageSentToSentry:
          this.state.numberCancelSlowMessageSentToSentry + 1,
      });
    }
  };

  render() {
    const { selectedView } = this.props;
    return (
      <React.Fragment>
        <Media
          query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
          render={() => (
            <span
              onMouseEnter={() => this.showOnHoverMessage()}
              onMouseLeave={() => this.showOnHoverMessage()}
              className={`download-speed ${selectedView} ${this.updateBackgroundColor()}`}
            >
              {this.props.intl.formatMessage({
                id: "download-speed-speed",
              })}
            </span>
          )}
        />
        {this.state.mouseOverMessage && (
          <div className={`download-speed__mouse-over-message`}>
            {this.props.intl.formatMessage({
              id: "download-speed-mouseover-message",
            })}
          </div>
        )}
        <Media
          query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
          render={() => (
            <span
              className={`download-speed ${selectedView} ${this.updateBackgroundColor()}`}
            >
              {this.props.intl.formatMessage({
                id: "download-speed-mobile",
              })}
            </span>
          )}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  session: state.sessionModel.session,
  downloadSpeed: state.sessionModel.downloadSpeed,
  isPageVisible: state.sessionModel.isPageVisible,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DownloadSpeed));
